(() => {
  if (window.NSCartRewards) return;
  const tokens = cart => (cart?.items || []).reduce((sum, item) => {
    if (item.sku === 'NS-REGALO-CLUB' || item.sku === 'NS-ENVIO-PROTEGIDO' || !(item.final_line_price > 0)) return sum;
    const units = parseInt(String(item.variant_title || '').trim(), 10) || 0;
    return sum + (item.handle !== 'nasostrips-antifaz' && units >= 30 ? Math.floor(units / 30) : 1) * item.quantity;
  }, 0);
  const model = (cart, state, config) => {
    const goal = Math.max(2, Number(state.goal || config.goal || 5));
    const bags = tokens(cart), logged = !!state.logged;
    const pending = logged && state.balanceReady === false;
    const saved = logged && !pending ? Math.min(goal, Number(state.shown || 0)) : 0;
    const projected = pending ? 0 : Math.min(bags, Math.max(0, goal - saved));
    const gift = (cart?.items || []).find(item => item.sku === 'NS-REGALO-CLUB');
    let status = !bags ? 'no_tokens' : logged ? 'logged' : 'guest';
    if (pending) status = 'unavailable';
    else if (logged && state.state === 'done') status = 'done';
    else if (logged && bags > 0 && gift?.quantity > 0) status = 'added';
    else if (logged && (state.state === 'owed' || Number(state.fill || 0) + bags >= goal) && bags > 0) status = 'pending_gift';
    else if (!logged && bags >= goal) status = 'guest_ready';
    return {goal, bags, logged, pending, saved, projected, after:saved + projected, ratio:pending ? 0 : (saved + projected) / goal, status};
  };
  let clubQueue = Promise.resolve();
  const syncClub = () => {
    const run = () => window.NSClubAPI?.sync(undefined, {celebrate:false}) || false;
    const next = clubQueue.then(run);
    clubQueue = next.catch(() => {});
    return next;
  };
  window.NSCartRewards = {tokens, model, syncClub};
  if (customElements.get('ns-cart-benefits')) return;
  customElements.define('ns-cart-benefits', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      try { this.config = JSON.parse(this.querySelector('[data-ns-benefits-config]').textContent); this.cart = JSON.parse(this.querySelector('[data-ns-benefits-cart]').textContent); } catch { return; }
      document.addEventListener('ns:club-ready', () => this.paint(), {signal:this.abort.signal});
      this.paint();
    }
    paint() {
      if (!this.config) return;
      const live = window.NSClubAPI?.state;
      const state = (live && !live.demo ? live : null) || {...this.config.state, balanceReady: !(this.config.state.logged && this.config.state.ordersCount > 20)};
      this.model = model(this.cart, state, this.config);
      const m = this.model, s = this.config.strings;
      const text = key => String(s[key] || '').replace(/\[(count|goal|value|saved|after)\]/g, (_, name) => ({count:m.bags, goal:m.goal, value:this.config.value, saved:m.saved, after:m.after})[name]);
      this.dataset.status = m.status;
      this.querySelector('[data-ns-club-order]').textContent = m.pending ? text('loading') : text(m.bags === 1 ? 'order' : 'order_plural');
      this.querySelector('[data-ns-club-message]').textContent = text(m.status);
      this.querySelector('[data-ns-club-legend]').textContent = m.logged && !m.pending ? text('confirmed') : text('projected');
      const link = this.querySelector('[data-ns-club-link]');
      link.firstChild.textContent = `${text(m.logged ? 'balance' : 'login')} `;
      link.href = m.logged ? this.config.pageUrl : this.config.loginUrl;
      const progress = this.querySelector('[data-ns-club-progress]');
      progress.setAttribute('aria-valuemax', String(m.goal)); progress.setAttribute('aria-valuenow', String(m.after)); progress.setAttribute('aria-valuetext', text('aria'));
      this.querySelector('[data-ns-club-fill]').style.transform = `scaleX(${m.ratio})`;
      this.querySelectorAll('[data-ns-club-marker]').forEach((marker, i) => { marker.classList.toggle('is-confirmed', i < m.saved); marker.classList.toggle('is-projected', i >= m.saved && i < m.after); });
    }
    animateFrom(ratio) {
      if (matchMedia('(prefers-reduced-motion:reduce)').matches || !Number.isFinite(ratio) || !this.model) return;
      const fill = this.querySelector('[data-ns-club-fill]'); fill.style.transform = `scaleX(${ratio})`;
      requestAnimationFrame(() => requestAnimationFrame(() => { if (this.isConnected) fill.style.transform = `scaleX(${this.model.ratio})`; }));
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  });
})();
